module.exports = __webpack_public_path__ + "static/img/looker.25b554d2.jpg";